import DateSelector from "Dashboard/components/DateSelector";
import { useAppDispatch } from "hooks/hooks";
import { useCallback, useEffect } from "react";
import { setStatisticDates } from "../slices/main.slice";
import { useSelector } from "react-redux";
import { selectState as mainSelectState } from "../slices/main.slice";
import { getSummaryStatistics, selectState } from "../slices/SummaryStatistics.slice";
import { FormatNumber } from "../services/statistics.service";

export const RightSection = () => {
  const { statistics } = useSelector(selectState);
  const dispatch = useAppDispatch();
  const { mainDateFrom } = useSelector(mainSelectState);

  useEffect(() => {
    if (mainDateFrom != null) {
      dispatch(getSummaryStatistics({ year: mainDateFrom.getFullYear() }));
    }
    console.log(statistics)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainDateFrom]);

  const selectDate = useCallback((data: { dateFrom: Date; dateTo: Date }) => {
    dispatch(
      setStatisticDates({ dateFrom: data.dateFrom, dateTo: data.dateTo })
    );
  }, []);

  return (
    <div className="statistics-right-total">
      <div className="selector mainSelector">
        <DateSelector
          showMonth={false}
          lastYearNumbers={5}
          selectDate={selectDate}
        />
        Izračunava statistiku date godine <br></br>na svim graficima i ukupnu
      </div>
      <span>
        <div className="green">{FormatNumber(statistics?.allProjectEarnings)} rsd</div>
        <label>
          Zarada iz projekata bez svih troškova na projektima <br></br> sa
          uračunatim utroškom našeg betona i asvalta
        </label>
      </span>
      <p>+</p>
      <span>
        <div className="green">{FormatNumber(statistics?.concretePlantEarnings)} rsd</div>
        <label>Zarada betonske baze</label>
      </span>
      <p>+</p>
      <span>
        <div className="green">{FormatNumber(statistics?.asphaltPlantEarnings)} rsd</div>
        <label>Zarada asvaltne baze</label>
      </span>
      <p>+</p>
      <span>
        <div className="green">{FormatNumber(statistics?.returnOnVat)} rsd</div>
        <label>Povraćaj PDV</label>
      </span>
      <p>-</p>
      <span>
        <div className="red">{FormatNumber(statistics?.fixedExpensesWithoutProject)} rsd</div>
        <label>Fiksni troškovi firme van projekta</label>
      </span>
      <span>
        <div className="red">{FormatNumber(statistics?.consumablesExpenses)} rsd</div>
        <label>Trošak potrošnih sredstava</label>
      </span>
      <span>
        <div className="red">{FormatNumber(statistics?.registrationsAndTachographExpenses)} rsd</div>
        <label>Registracije i tahografi</label>
      </span>
      <p>=</p>
      <span className="totalEarnings">
        <div className="blue">{FormatNumber(statistics?.totalCompanyEarnings)} rsd</div>
        <label> Ukupna zarada firme</label>
      </span>
      <p></p>
      <p></p>
      <span>
        <div>{FormatNumber(statistics?.estimatedResourcesValuation)} rsd</div>
        <label> Procenjena vrednost resursa</label>
      </span>
      <span className="margin-bottom">
        <div>{FormatNumber(statistics?.investments)} rsd</div>
        <label> Investicije</label>
      </span>
      <span>
        <div>{FormatNumber(statistics?.loansAmountTakenTotal)} rsd</div>
        <label> Kredita ukupno uzeli</label>
      </span>
      <span className="margin-bottom">
        <div>{FormatNumber(statistics?.loansAmountRemaining)} rsd</div>
        <label> Kredita ostalo da vratimo</label>
      </span>
      <span>
        <div>-{FormatNumber(statistics?.borrowingsAmountTotal)} rsd</div>
        <label> Pozajmice </label>
      </span>
      <span>
        <div>{FormatNumber(statistics?.checkmark)} rsd</div>
        <label> Kvačkica</label>
      </span>
      <div className="dottedLine"></div>
    </div>
  );
};
